import React, {useEffect} from 'react';
import {api} from "careand-redux/api/ApiThunks";
import {useAppDispatch} from "careand-redux/useAppDispatch";

export default function markUnread(WrappedComponent, type) {
  return props => {
    const dispatch = useAppDispatch();
    const {unreadItem, unreadItems = []} = props;

    useEffect(() => {
      let items = unreadItems;
      if (unreadItem) items = [unreadItem];
      items.forEach(item => {
        if (!item.read) {
          dispatch(api.HealthRecords.markHealthRecordRead({patientId: item.patient_id, type, id: item.id}));
        }
      });
    }, []);

    return <WrappedComponent {...props} />;
  }
}

export const MarkRead = ({type, item, children}) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!!item && !item.read) {
      dispatch(api.HealthRecords.markHealthRecordRead({patientId: item.patient_id, type, id: item.id}));
    }
  }, [item, type])

  return children;
}
